import { render, staticRenderFns } from "./authorize-google-btn.vue?vue&type=template&id=6e15dc80&scoped=true&"
import script from "./authorize-google-btn.vue?vue&type=script&lang=js&"
export * from "./authorize-google-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15dc80",
  null
  
)

export default component.exports